// Profitability domain types — mirror of sauron backend schemas (doc 06)
// Ported verbatim from sauron/frontend/src/domain/profitability/types.ts.
// Must stay in sync with backend/app/schemas/profitability.py.

export type FeeBasis = {
    referralFeeRate: number;
    fbaFixedFee: number;
    returnsRate: number;
    returnsRecoveryRate: number;
    referralFeeKnown: boolean;
    fbaFeeKnown: boolean;
    returnsRateKnown: boolean;
    dimensionsKnown: boolean;
    feesDerivedFromDimensions: boolean;
};

export type UserEconomicsInput = {
    businessModel: 'private_label' | 'wholesale';
    cogs: number | null;
    advertisingEnabled: boolean;
    tacosPercent: number | null;
};

export type DerivedMetrics = {
    advertisingCostPerUnit: number;
    returnsCostPerUnit: number;
    amazonFeesAtCurrentPrice: number;
    baseProfitPerUnit: number;
    profitPerUnit: number;
    netMarginPercent: number;
    roiOnCogsPercent: number;
    displayedBreakEvenPrice: number | null; // null = safe fallback (infinite)
    baseBreakEvenAcosPercent: number;
    displayedBreakEvenAcosPercent: number;
    breakEvenSafeFallback: boolean;
};

export type ConfidenceLevel = 'High' | 'Medium' | 'Low';
export type ConfidenceModel = {
    level: ConfidenceLevel;
    reasonText: string;
};

export type VerdictState = 'good' | 'borderline' | 'weak';
export type VerdictModel = {
    state: VerdictState;
    title: string;
    body: string;
};

export type CardStates = {
    profit: 'positive' | 'negative';
    netMargin: 'positive' | 'caution' | 'negative';
    roiOnCogs: 'positive' | 'caution' | 'negative';
    amazonFees: 'neutral';
    breakEvenPrice: 'neutral';
    breakEvenAcos: 'positive' | 'caution' | 'negative';
};

export type BiggestImpactEntry = {
    label: string;
    amount: number;
    sharePercent: number;
};

export type ExplanationModel = {
    assumptionsChips: string[];
    used: string[];
    assumed: string[];
    biggestImpact: string;
    rankedContributors: BiggestImpactEntry[];
};

export type ProfitabilityViewModel = {
    metrics: DerivedMetrics;
    confidence: ConfidenceModel;
    verdict: VerdictModel;
    cardStates: CardStates;
    explanation: ExplanationModel;
};

// Steady-state TACOS preset — always used by Profitability Check (Patch v2.1)
export const STEADY_STATE_TACOS_PERCENT = 12;
